module.exports = __webpack_public_path__ + "static/media/marvelsearchheroes.450b42f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/projetos/marvelsearchheroes.png
// module id = 92
// module chunks = 0